<template>
  <div
    id="chatinput"
    style="bottom: 0; right: 0; left: 0;"
    :style="{ position: isMobile ? 'fixed' : 'absolute' }"
  >
    <slot name="header"></slot>
    <!-- border-top: 1px solid #eee;  -->
    <div style="background: white; position: relative">
      <form v-on:submit.prevent="noop">
        <v-layout
          style="display: flex; flex-direction: column; padding-top: 5px; padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"
        >
          <!-- <v-avatar size="30" class="ma-1">
            <img
              @error="onError"
              :src="
                'https://graph.facebook.com/' +
                  $store.state.livechat.pageid +
                  '/picture?width=100&height=100&SameSite=None'
              "
              style="border: 1px solid #eee"
            />
          </v-avatar> -->

          <!-- searchbox and send button -->
          <v-flex class="pa-1" style="display: flex; flex-direction: row; align-items: center;">
            <autoresize-textarea
              v-model="text"
              rows="1"
              placeholder="พิมพ์ข้อความ"
              style="
                resize: none;
                border: none;
                padding: 5px;
                outline: 0px;
                background: none;
                display: inline-block;
                color: #2C2C2C;
                font-weight: 600;
              "
              @pressEnter="$refs.sendBtn.click()"
            ></autoresize-textarea>
            <span>
              <v-btn
                ref="sendBtn"
                depressed
                fab
                small
                @click="clickSendBtn"
                v-tooltip.top="'Send'"
                style="background: none;"
              >
                <!-- <v-icon style="color: linear-gradient(274.72deg, #0C2F53 7.12%, #26588B 99.76%)">mdi-send</v-icon> -->
                <img src="/static/img/sendMessageButton.svg" alt="" />
              </v-btn>
            </span>
          </v-flex>

          <!-- all button -->
          <!-- class="text-xs-right" -->
          <v-flex
            shrink
            class="pa-1"
            style="white-space: nowrap; display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
          >
            <span>
              <!-- send file -->
              <v-dialog v-model="showUploadFile" max-width="700">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Send File'" v-on="on">
                      <!-- <i style="font-size: 20px" class="fas fa-file-alt"></i> -->
                      <img src="/static/img/attach_file.svg" alt="" />
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <div class="text-xs-right">
                    <v-btn @click="showUploadFile = false" fab flat color="primary" small>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text v-if="showUploadFile">
                    <div>
                      <uploadalltype
                        ref="answer"
                        v-model="file_url"
                        @onUploaded="onUploadedFile($event)"
                        v-validate
                        :multiple="true"
                      ></uploadalltype>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <!-- send img -->
              <v-dialog v-model="showUploadImg" max-width="700" style="left: 0px !important;">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Send Image'" v-on="on">
                      <!-- <v-icon class="outlined">photo_size_select_actual</v-icon> -->
                      <img src="/static/img/send_img.svg" alt="" />
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <div class="text-xs-right">
                    <v-btn @click="showUploadImg = false" fab flat color="primary" small>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text v-if="showUploadImg">
                    <div>
                      <uploadfile
                        ref="answer"
                        v-model="image_url"
                        @onUploaded="onUploaded"
                        v-validate
                        :multiple="true"
                      ></uploadfile>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <!-- quick message -->
              <v-dialog v-model="showIntent" max-width="700">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Quick Message'" v-on="on">
                      <!-- <v-icon class="outlined">forum</v-icon> -->
                      <img src="/static/img/quick_message.svg" alt="" />
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <v-card-text>
                    <div class="text-xs-right">
                      <v-btn @click="showIntent = false" fab depressed color="primary" small>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <intent
                      :key="$store.state.livechat.pageid"
                      :pageid="$store.state.livechat.pageid"
                      :showDefault="false"
                      @sendToLivechat="sendMessage"
                    ></intent>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </span>

            <!-- sticker -->
            <span v-if="app == 'line'" style="width: 56px; display: flex; justify-content: center;">
              <v-btn icon style="margin: 0" v-tooltip.top="'Sticker'" @click="showSticker = true">
                <!-- <v-icon class="outlined">face</v-icon> -->
                <img src="/static/img/send_sticker.svg" alt="" />
              </v-btn>
            </span>
          </v-flex>
        </v-layout>
      </form>

      <sticker-list v-model="showSticker" @sendSticker="sendSticker"></sticker-list>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from './AutoresizeTextarea'
import { mapGetters } from 'vuex'
import Intent from '@/components/view/intent/Intent'
import uploadfile from '@/components/elements/uploadfile'
import uploadalltype from '@/components/elements/uploadalltype'
import moment from 'moment'
import StickerList from '@/components/elements/StickerList'

import api from '@/api'

export default {
  props: ['value', 'app'],
  data: function() {
    return {
      type: 'text',
      text: '',
      enableSend: false,
      user: this.value,
      isMobile: false,
      showIntent: false,
      showUploadImg: false,
      image_url: null,
      showUploadFile: false,
      file_url: null,
      showSticker: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      botlist: 'botlist'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    isUnlock() {
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && this.$store.state.livechat.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },
    messageAvailableCount: function() {
      var vm = this
      if (vm.loadingLinePushMessageCount) {
        return false
      }
      var area = vm.linePushMessageCount.find(el => {
        return el.uu_areaname == vm.user.uu_areaname
      })
      if (area) {
        return area.count
      } else {
        return false
      }
    }
  },
  components: {
    AutoresizeTextarea,
    Intent,
    uploadfile,
    uploadalltype,
    StickerList
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted: function() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    clickSendBtn() {
      let data = {
        a_val: JSON.stringify([[{ text: this.text, type: 'text' }]]),
        type: 'json'
      }
      this.sendMessage(data)
    },
    chatboxEnter(event) {},
    sendSticker({ packageid, stickerid }) {
      let data = {
        a_val: `[[{ "stickerid": ${stickerid}, "type": "sticker", "packageid": ${packageid} }]]`,
        type: 'json'
      }

      this.sendMessage(data)
    },
    onUploadedFile(url) {
      let fileN = url[0].split('/')
      console.log(url[0])
      console.log(fileN[fileN.length - 1])
      let fileName = fileN[fileN.length - 1]
      this.enableSend = true
      var files = [[]]
      if (typeof url == 'string') {
        

        if (url.indexOf('.mp4') != -1) {
          files[0].push({ source: url, type: 'video' })
        } else {
          files[0].push({ filename:fileName, text: url, type: 'text' })
        }
      } else {
        url.forEach(el => {
          if (el.indexOf('.mp4') != -1) {
            files[0].push({ source: el, type: 'video' })
          } else {
            files[0].push({ filename:fileName, text: el, type: 'text' })
          }
        })
      }
      let data = {
        a_val: JSON.stringify(files),
        type: 'json'
      }

      this.sendMessage(data)
      this.file_url = null
      this.showUploadFile = false
    },
    onUploaded(url) {
      this.enableSend = true
      var images = [[]]
      if (typeof url == String) {
        images[0].push({ image_url: url, type: 'image' })
      } else {
        url.forEach(el => {
          images[0].push({ image_url: el, type: 'image' })
        })
      }
      let data = {
        a_val: JSON.stringify(images),
        type: 'json'
      }

      this.sendMessage(data)
      this.showUploadImg = false
      this.image_url = null
    },
    newline() {
      this.text = '${this.text}\n'
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    sendMessage: function(event) {
      this.showIntent = false
      // let isIntent = event && event.type == 'intent'
      let vm = this
      if (vm.$store.state.livechat.pageid == null && vm.$store.state.livechat.currentUser == null) {
        return false
      }
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false

      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.$store.state.livechat.currentUser.userid,
        app: vm.$store.state.livechat.app,
        adminid: vm.$store.state.userid,
        messagetype: event.type,
        messagevalue: event.type == 'json' ? event.a_val : vm.text,
        page_access_token: bot.page_access_token
      }

      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata:
          event.type == 'json'
            ? JSON.parse(event.a_val).length > 0
              ? JSON.stringify(JSON.parse(event.a_val)[0])
              : event.a_val
            : vm.text,
        messagetype: event.type,
        pageid: vm.$store.state.livechat.pageid,
        timestamp: new Date(),
        userid: vm.$store.state.livechat.currentUser.userid
      }
      vm.$emit('onSendMessage', message)
      vm.text = ''

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.log(error)
          vm.$swal.fire({
            type: 'error',
            text: 'ไม่สามารถส่งข้อความได้'
          })
          return
        }
        vm.updateReadchat()

        // vm.$store.dispatch('loading')
      })
    },
    onResize() {
      this.isMobile = window.innerWidth < 960
    },
    async updateReadchat() {
      if (this.$store.state.livechatadminreadpage.includes(this.$store.state.livechat.pageid)) {
        let vm = this
        api.adminreadchat(
          {
            adminid: this.$store.state.userid,
            userid: this.user.userid
          },
          () => {
            vm.$nextTick(() => {
              user.adminread = true
              vm.$store.commit('SET_LIVECHAT_USER', user)
              vm.$forceUpdate()
            })
          }
        )
      }
    }
  },
  watch: {
    text: function(newVal, oldVal) {
      if (newVal && newVal.trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    value: function(newVal, oldVal) {
      this.user = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatinput.vue